<template>
<div>
    <div class="w-1/2 md:w-full">
        <form @submit.prevent="sendEmail">
            <div class="border mt-4 rounded">
                <label class="p-1" for="from">To</label>
                <input type="text" class="w-full outline-none" :value="id">
                <p class="text-xs text-red-500" v-if="messageToValidity === 'invalid' ">this field cannot be empty</p>
            </div>
            <div class="border rounded mt-4">
                <label for="from" class="p-1">Subject</label>
                <input type="text" class="w-full outline-none" v-model="subject">
                <p class="text-xs text-red-500" v-if="subjectValidity === 'invalid' ">this field cannot be empty</p>
            </div>
            <textarea name="message" id="message" class="w-full border mt-4 rounded" rows="10" v-model="message"></textarea>
            <p class="text-xs text-red-500" v-if="messageValidity === 'invalid' ">this field cannot be empty</p>
            <div class="mt-4">
                <button class="bg-blue-700 text-white p-2 rounded">Send Message<i v-if="isLoading" class="fa fa-spin fa-spinner"></i></button>
            </div>
        </form>
    </div>
    <SuccessfulModal
    @click="close"
    v-show="isModalVisible"
    :message="successMessage"
    />
    <ErrorModal
    @click="closeErrorModal"
    v-show="errorModal"
    :message="errorMessage"
    />
</div>
</template>

<script>
import axios from 'axios';
import SuccessfulModal from '../../../LandingPages/SuccessfulModal.vue';
import ErrorModal from '../../ErrorModal.vue';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    props: ["id"],
    components : {SuccessfulModal, ErrorModal},

    data() {
        return {
            messageTo: "",
            subject: "",
            message:"",
            messageToValidity: "",
            messageValidity: "",
            subjectValidity: "",
            emailTo: this.email,
            isLoading: false,
            isModalVisible: false,
            errorModal: false,
            errorMessage:"",
            successMessage: ""
        }
    },

    methods: {
        close() {
            this.isModalVisible = false;
        },
        closeErrorModal() {
            this.errorModal = false;
        },
        sendEmail() {
        if(!this.subject) {
            this.subjectValidity = 'invalid';
            setTimeout(() => {
            this.subjectValidity = '';
            }, 3000);
        } else if(!this.message) {
            this.messageValidity = 'invalid';
            setTimeout(() => {
            this.messageValidity = '';
            }, 3000);
        } else {
            this.isLoading = true;
            axios({
            method: 'POST',
            url: `${url}/v1/web/users/email/send`,
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer' + localStorage.getItem("token"),
                'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
            },
            data: {
                to: this.id,
                subject: this.subject,
                message: this.message
            }
            })
            .then((response) => {
                response;
                this.isModalVisible = true;
                this.isLoading = false;
                this.successMessage = "Email Sent Successfully"
                this.message = '';
                this.subject = '';
            })
            .catch((error) => {
                if(error) {
                    this.errorMessage = error.response.data.message;
                    this.errorModal = true;
                }
            })
        }
        
    }
    }
    
}
</script>